__turbopack_context__.v({
  "link": "styles-module__SJdGBa__link",
  "selected-link": "styles-module__SJdGBa__selected-link",
});
